import { useState } from 'react';

const useModal = function() {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalID, setModalID] = useState(null);

  const handleOpenModal = (modalID = null) => {
    setModalIsOpen(true);
    setModalID(modalID);
  }

  const handleCloseModal = () => {
    setModalIsOpen(false);
  }

  return {
    modalIsOpen,
    modalID,
    handleOpenModal,
    handleCloseModal,
  }
};

export default useModal;